/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/svenskdam/components/standalone/ScrollArticleLabel/theme';

export const ScrollArticleLabelTheme = theme;
